import { render, staticRenderFns } from "./Ecilia.vue?vue&type=template&id=5415be8d&scoped=true&"
import script from "./Ecilia.vue?vue&type=script&lang=js&"
export * from "./Ecilia.vue?vue&type=script&lang=js&"
import style0 from "./Ecilia.vue?vue&type=style&index=0&id=5415be8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5415be8d",
  null
  
)

export default component.exports